import ListItem from '../../utils/ListItem';

function DocumentsListItem(props) {
  const typeLabel = [props.docType, props.subType].filter(Boolean).join(' / ');
  return (
    <ListItem
      primary={props.details || 'No description'}
      meta={typeLabel}
    />
  );
}

export default DocumentsListItem;
